import { isArray, get, set, omit, isString, omitBy } from 'lodash';

/**
 * 把实际表单的值拍平，如
 *  字段 name: ['field', 'value']
 *  值 value: ['status', 'tang']
 * 会被转成 {field: 'status', 'value': 'tang'}
 * @param filters IFilters
 * @param value any
 */
export const flattenFiltersValue = (filters, value) => {
  return filters === null || filters === void 0 ? void 0 : filters.reduce((total, {
    name
  }) => {
    if (isArray(name)) {
      name.forEach((i, index) => {
        total[i] = get(value, [...name, index]);
      });
    }

    return total;
  }, { ...value
  });
}; // 和上面相反的过程

export const nestFiltersValue = (filters, value) => {
  return filters === null || filters === void 0 ? void 0 : filters.reduce((total, {
    name,
    defaultValue
  }) => {
    if (isArray(name)) {
      const groupValue = name.reduce((value, currentField, index) => {
        const newValue = [...value, total[currentField] || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[index])];
        return newValue;
      }, []);
      const base = omit(total, name);
      set(base, name, groupValue);
      return base;
    }

    return total;
  }, { ...value
  });
};
export const calFlattenedDefaultValue = filters => {
  return filters === null || filters === void 0 ? void 0 : filters.reduce((total, {
    name,
    defaultValue
  }) => {
    if (isArray(name)) {
      name.forEach((field, index) => {
        total[field] = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[index];
      });
      return total;
    }

    if (name) {
      return { ...total,
        [name]: defaultValue
      };
    }

    return total;
  }, {});
};
export const calDefaultColumnFiltersValue = (columns, search) => {
  const calcValue = columns.reduce((total, column) => {
    const dataIndex = column.dataIndex;

    if (column.filterType) {
      if (search[dataIndex] === undefined) {
        return { ...total,
          [dataIndex]: column.defaultValue || column.defaultFilteredValue
        };
      }

      return { ...total,
        [dataIndex]: (isString(search[dataIndex]) ? [search[dataIndex]] : search[dataIndex]).filter(i => i !== undefined && i !== '')
      };
    }

    return total;
  }, {});
  return omitBy(calcValue, v => v === undefined);
};
export const string2hash = str => {
  let hash = 0;

  if (str.length === 0) {
    return hash;
  }

  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }

  return hash;
};
export const diffObj = (newObj, old) => {
  return Object.entries(newObj).reduce((pre, i) => {
    const [newKey, newValue] = i;

    if (!(old[newKey] && old[newKey] === newValue)) {
      pre.push(newKey);
    }

    return pre;
  }, []);
};
//# sourceMappingURL=es/utils.js.map